import { Button } from '@/components/ui/button';
import { Dialog, DialogClose, DialogContent, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Trash } from 'lucide-react';
import React from 'react'
import { useDeleteBlog } from '@/lib/hooks/blogs/delete/useDeleteBlog';
import toast from 'react-hot-toast';

interface DeleteBlogInterface {
    blogId: string;
}
const DeleteBlog = ({ blogId }: DeleteBlogInterface) => {
    const { mutate: deleteBlog } = useDeleteBlog();
    const handleDeleteBlog = () => {
        deleteBlog(blogId);
        toast.success('Blog deleted successfully');
    }
    return (
        <Dialog>
            <DialogTrigger asChild className='z-[99]'>
                <Button
                    variant={"outline"}
                    className="group relative overflow-hidden rounded-lg border-2 border-red-400 py-2 font-medium text-red-400 transition-all duration-300 hover:border-red-500 hover:text-red-500 hover:shadow-lg"
                >
                    <span className="relative z-10 flex items-center gap-2">
                        <Trash className="h-4 w-4 transition-transform duration-200 group-hover:scale-110" />
                    </span>
                    <span className="absolute inset-0 -z-0 bg-red-400 opacity-0 transition-all duration-300 group-hover:opacity-10"></span>
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogTitle className="flex flex-col gap-1 text-center text-lg font-semibold text-gray-800">
                    <span>Are you sure you want to delete this blog?</span>
                    <span className="text-sm font-normal text-gray-500">This action is irreversible.</span>
                </DialogTitle>


                <div className='flex justify-end gap-3'>
                    <DialogClose asChild>
                        <Button
                            variant="outline"
                            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-400"
                        >
                            Cancel
                        </Button>
                    </DialogClose>
                    <DialogClose asChild>
                        <Button
                            onClick={handleDeleteBlog}
                            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600 transition-colors duration-200 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-red-400 shadow-sm hover:shadow-red-200"
                        >
                            Delete
                        </Button>
                    </DialogClose>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteBlog